<div class="lp-story-activity" style="width: 100%; height: 100%">
  @if (storyActivity().story) {
    @let story = storyActivity().story;
    @if (story) {
      <lp-story [story]="story" style="display: block; width: 100%; height: 100%" (finished)="finish()" />
    }
  }
</div>
